import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconShareTabStyle0 = gravityIconIndividualCss;

const GravityIconShareTab = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '0187f4b4e118557a11a49b37574fba5b4875da5d', color: this.color, size: this.size }, h("svg", { key: '25a774d4fd23558cf5ece2c85f2f29e4526d5e58', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'd547045b380f179d1e0fd8ce6b778e993564a24b', d: "M10.25 7H7.257a.5.5 0 0 1-.353-.853l3.742-3.742a.5.5 0 0 1 .708 0l3.742 3.742a.5.5 0 0 1-.354.854H11.75v5.495a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V7.001Z", fill: "currentColor" }), h("path", { key: 'a6d954e9e2fc5a5fdf6d1b3511c5ea693af0a6a7', d: "M14.5 9h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-1v7h9v-7h-1a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5Z", fill: "currentColor" }))));
    }
};
GravityIconShareTab.style = GravityIconShareTabStyle0;

export { GravityIconShareTab as gravity_icon_share_tab };

//# sourceMappingURL=gravity-icon-share-tab.entry.js.map